import type { RawAxiosRequestConfig } from 'axios'
import type { IAssetFileUploaded, ICreateOrUpdateFile, IFileUploaded, IUploadFile } from '~/types/file'
import type { IFileWithAdditionalData } from '~/types/video'

import config from '~/config'
import { request } from '~/utils/request'

/** @doc https://dev.files.mwm-storage.mwmwebapis.com/#post-/file */
export const createFile = ({ mimeType, name, size }: ICreateOrUpdateFile): Promise<IFileUploaded> => {
  return request({
    data: {
      mime_type: mimeType,
      name,
      size,
    },
    method: 'POST',
    url: `${config.STORAGE_API_V2}/file`,
  })
}

export const uploadFile = ({ file, mimeType, uploadUrl }: IUploadFile): Promise<void> => {
  const config: RawAxiosRequestConfig = {
    data: file,
    method: 'PUT',
    url: uploadUrl,
  }

  if (mimeType) {
    config.headers = {
      'Content-Type': mimeType || '',
    }
  }

  return request(config, false)
}

export const createAssetFile = ({ mimeType, name, size }: ICreateOrUpdateFile): Promise<IAssetFileUploaded> => {
  return request({
    data: {
      mime_type: mimeType,
      name,
      size,
    },
    method: 'POST',
    url: `${config.ASSET_MANAGER_API}/file`,
  })
}

export const uploadVideoFile = ({
  file,
  uploadUrl,
}: {
  file: IFileWithAdditionalData
  uploadUrl: string
}): Promise<void> => {
  return request(
    {
      data: file,
      method: 'PUT',
      url: uploadUrl,
    },
    false
  )
}

/** @doc https://dev.files.mwm-storage.mwmwebapis.com/#get-/file/-fileID- */
export const getFile = ({ fileId }: { fileId: string }): Promise<IFileUploaded> => {
  return request({
    url: `${config.STORAGE_API_V2}/file/${fileId}`,
  })
}
